import request from '@/config/axios'

/** 吉凶等级取值（与星级绑定：大吉5 / 吉4 / 中吉3 / 平2 / 凶1） */
export const DREAM_LEVELS = ['大吉', '吉', '中吉', '平', '凶'] as const

/** 吉凶等级 → 星级映射（星级由后端按等级推导，前端只读展示） */
export const DREAM_LEVEL_STAR: Record<string, number> = {
  大吉: 5,
  吉: 4,
  中吉: 3,
  平: 2,
  凶: 1
}

/** 情境解读（问题 + 解答） */
export interface DreamScenarioVO {
  q: string
  a: string
}

/** 解梦词条 VO */
export interface DreamEntryVO {
  id?: number
  word: string
  categoryId: number
  alias?: string
  summary?: string
  classic?: string
  scenarios: DreamScenarioVO[]
  psychology?: string
  level: string
  /** 只读：由后端按 level 推导（大吉5/吉4/中吉3/平2/凶1），保存时无需传 */
  star?: number
  hotFlag: boolean
  status: number
  // ===== 分页列表附加字段 =====
  categoryName?: string
  scenarioCount?: number
  viewCount?: number
  updateTime?: Date
}

/** 解梦分类 VO（编码已移除，分类仅以 id 关联、name 唯一） */
export interface DreamCategoryVO {
  id?: number
  name: string
  icon?: string
  sort?: number
  status?: number
  // ===== 分页列表附加字段 =====
  entryCount?: number
  updateTime?: Date
}

// ========== 解梦词条 ==========

export const DreamEntryApi = {
  // 查询解梦词条分页
  getPage: (params: PageParam) => {
    return request.get({ url: '/xuanxue/dream-entry/page', params })
  },
  // 查询解梦词条详情（含全字段）
  get: (id: number) => {
    return request.get({ url: '/xuanxue/dream-entry/get?id=' + id })
  },
  // 新增解梦词条
  create: (data: DreamEntryVO) => {
    return request.post({ url: '/xuanxue/dream-entry/create', data })
  },
  // 修改解梦词条
  update: (data: DreamEntryVO) => {
    return request.put({ url: '/xuanxue/dream-entry/update', data })
  },
  // 修改解梦词条状态
  updateStatus: (id: number, status: number) => {
    return request.put({ url: '/xuanxue/dream-entry/update-status', params: { id, status } })
  },
  // 修改解梦词条热门标记
  updateHot: (id: number, hotFlag: boolean) => {
    return request.put({ url: '/xuanxue/dream-entry/update-hot', params: { id, hotFlag } })
  },
  // 删除解梦词条
  delete: (id: number) => {
    return request.delete({ url: '/xuanxue/dream-entry/delete?id=' + id })
  }
}

// ========== 解梦分类 ==========

export const DreamCategoryApi = {
  // 获取分类精简列表
  getSimpleList: async (): Promise<DreamCategoryVO[]> => {
    return await request.get({ url: '/xuanxue/dream-category/simple-list' })
  },
  // 查询解梦分类分页
  getPage: (params: PageParam) => {
    return request.get({ url: '/xuanxue/dream-category/page', params })
  },
  // 新增解梦分类
  create: (data: DreamCategoryVO) => {
    return request.post({ url: '/xuanxue/dream-category/create', data })
  },
  // 修改解梦分类
  update: (data: DreamCategoryVO) => {
    return request.put({ url: '/xuanxue/dream-category/update', data })
  },
  // 修改解梦分类状态
  updateStatus: (id: number, status: number) => {
    return request.put({ url: '/xuanxue/dream-category/update-status', params: { id, status } })
  },
  // 删除解梦分类
  delete: (id: number) => {
    return request.delete({ url: '/xuanxue/dream-category/delete?id=' + id })
  }
}
